// extracted by mini-css-extract-plugin
module.exports = {"view-map":"Map_view-map__2Vah8"};